<script>
import config from '../config.js'
import { spring } from 'svelte/motion'
import { derived } from 'svelte/store'
import { svgzoom } from '../utils/transition.js'

export let img
export let index
export let sprite
const sprungSprite = spring(sprite, {
	stiffness: 0.05,
	damping: 1
})
let clip = 'none'
$: {
  if (sprite && sprungSprite) sprungSprite.set(sprite)
}

const clipCorners = [[0,0],[0,-1],[-1,-1],[-1,0],[-1,1],[0,1],[1,1],[1,0],[1,-1]]
function generateCoinClipPath (fraction) {
  const points = clipCorners.slice(0, 2 + Math.floor(fraction/0.125))
  points.push([
    2 * Math.sin(-fraction * 2 * Math.PI),
    -2 * Math.cos(-fraction * 2 * Math.PI)
  ])

  const polygonPoints = points.map(coord => {
    return `${((coord[0] + 1) * 50).toFixed(2)}% ${((coord[1] + 1) * 50).toFixed(2)}%`
  }).join(', ')

  return `polygon(${polygonPoints})`
}

let ticks = 0
const clipPath = derived(sprungSprite, $sprite => {
	/* BEGIN WTF */
	// for some reason, the svg clip-path can
	// get stuck during tweening, and end up
	// offset from the clipped element.
	//
	// probably the calculated clip-path string
	// stabilises before the clipped element
	// finishes moving, and the compositor
	// doesn't realise it needs to keep updating
	// the clipping mask.
	//
	// if so, solution would be to force small
	// changes to the clip-path string until the
	// clipped element finishes moving, to prompt
	// the compositor to keep the clipping mask
	// up to date.
	//
	// this is a dirty hack to periodically
	// and explicitly (in all senses of the word)
	// force that recalculation of the clip-path,
	// which does seem to unstick things.
	//
	// every 5 calls to this derived callback, we
	// force a change to the clip-path by adding
	// a small delta
	ticks++
	if (ticks > 5 && $sprite.fraction < 1) {
		sprungSprite.update(sprite => {
			ticks = 0
			sprite.fraction += 0.0001
			return sprite
		})
	}
	/* END WTF */
  if ($sprite.fraction < 1) return generateCoinClipPath($sprite.fraction)
  else return 'none'
})
</script>

<style type="text/scss">
  .coinSprite {
    transform-origin: center;
  }
</style>

<image
  href="{img}"
  id="coin{index}"
  class="coinSprite"
  x="{$sprungSprite.x}"
  y="{$sprungSprite.y}"
  width="{$sprungSprite.w}"
  height="{$sprungSprite.w}"
  clip-path="{$clipPath}"
	clipPathUnits="objectBoundingBox"
  transition:svgzoom
/>
